import apiClient from '@/services/OpenBankingClient'

export default {
  fetchAllApplications (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/applications',
      params,
      options
    )
  },
  createApplication (params, options) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/applications',
      params,
      options
    )
  },
  updateApplication (id, params, options) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/applications/${id}`,
      params,
      options
    )
  },
  deleteApplication (id, options) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/applications/${id}`,
      options
    )
  },
  fetchAllPayments (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/payments',
      params,
      options
    )
  },
  fetchInstitutions (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/institutions',
      params,
      options
    )
  },
  toggleInstitutionState (id, active) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/institutions/${id}/toggle`,
      { active }
    )
  },
  uploadLogo (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/applications/logo',
      data
    )
  }
}
